exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ImageBox {\n  width: 100%;\n  position: relative;\n  z-index: 1000; }\n  .ImageBox .ImageBox-ImageWrapper {\n    display: flex;\n    height: 250px;\n    max-width: 100%;\n    width: 100%;\n    padding: 0;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.1); }\n  .ImageBox .ImageBox-Image {\n    border-radius: 3px;\n    max-width: 100%;\n    max-height: 100%; }\n  .ImageBox .Icon {\n    transform: scale(1.4); }\n  .ImageBox .TextBox {\n    border-bottom: none; }\n    .ImageBox .TextBox .TextBox-Icon {\n      padding: 5px 5px 5px 0; }\n  .ImageBox stack.TextBox-Wrapper.Field {\n    padding-top: 2px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 0 0 5px 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Forms/ImageBox/ImageBox.scss
// module id = 392
// module chunks = 0